"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.initJs = void 0;
const pickr_1 = __importDefault(require("@simonwep/pickr"));
const tabs_1 = require("./tabs");
const view_1 = require("./view");
const model_1 = require("./model");
const ui_model_1 = require("./ui-model");
let editor;
let guideType;
let miniPreviewer;
let previewer;
const EDITOR_MAX_WIDTH = 630;
const EDITOR_MIN_WIDTH = 180;
const VIEWPORT_MARGIN = 24;
const PREVIEW_MIN_HEIGHT = 240;
const PREVIEW_MAX_HEIGHT = 1200;
const DOWNLOAD_MIN_HEIGHT = 1400;
const PRINT_RATIO = 3;
const BORDER_LIMIT = 6;
const COLOR_LIMIT = 12;
const POINTER_EVENTS = "PointerEvent" in window;
const POINTER_MOVE = POINTER_EVENTS ? "pointermove" : "mousemove";
const pickers = {};
const quilt = new model_1.Quilt();
const ui = new ui_model_1.UI();
const toolForId = {
    "tool-paint": ui_model_1.Tool.Paint,
    "tool-spin-r": ui_model_1.Tool.SpinR,
    "tool-spin-l": ui_model_1.Tool.SpinL,
    "tool-flip-h": ui_model_1.Tool.FlipH,
    "tool-flip-v": ui_model_1.Tool.FlipV
};
function showActiveColor(slot) {
    const view = document.getElementById(`color-active-${slot}`);
    if (view) {
        const colorIndex = ui.paintColors[slot];
        view.style.backgroundColor = quilt.colorSet[colorIndex];
    }
    else {
        console.error("No element for '#color-active-%d'", slot);
    }
}
function setPaintColor(i, slot = 0) {
    const paints = ui.paintColors;
    const prev = paints[slot];
    paints[slot] = i;
    for (let s = 0; s < paints.length; s++) {
        if (paints[s] === i) {
            showActiveColor(s);
        }
    }
    ui.selectedTool = ui_model_1.Tool.Paint;
    ui.setCursor(editor.canvas, getPaintClass());
    if (ui.moveStatus === ui_model_1.Move.Ignore) {
        ui.moveStatus = ui_model_1.Move.Allow;
    }
    if (slot === 0 && i !== prev) {
        document.getElementById(`color${prev}`).classList.remove("selected");
        document.getElementById(`color${i}`).classList.add("selected");
    }
}
function getPaintClass() {
    const paintNode = document.getElementById("tool-paint");
    return paintNode?.getAttribute("data-cursor-type") || "";
}
function getPalette(element) {
    if (!element) {
        return new model_1.Palette("#00ccff");
    }
    let colorText = element.getAttribute("data-initial-palette") || "#ff00ff";
    const modeSep = colorText.indexOf("|");
    if (modeSep > -1) {
        if (window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches) {
            colorText = colorText.substring(modeSep + 1);
        }
        else {
            colorText = colorText.substring(0, modeSep);
        }
    }
    const colors = colorText.split(/,\s*/);
    return new model_1.Palette(...colors);
}
function isChecked(id) {
    const node = document.getElementById(id);
    return node && node.checked;
}
function initJsCore() {
    initColors();
    initBorders();
    initTools();
    initQuiltResize();
    initPrint();
    const sizeInput = document.getElementById("cell-size");
    quilt.blockCells =
        sizeInput && sizeInput instanceof HTMLInputElement ? parseInt(sizeInput.value, 10) : 5;
    const tabs = initTabs();
    if (tabs) {
        tabs.addEventListener("change", onTabChange);
        ui.tabs = tabs;
    }
    document.getElementById("app").classList.remove("hide");
    window.addEventListener("resize", onResizeViewport);
    onResizeViewport();
}
function criticalError(e) {
    let message;
    try {
        console.error(e);
        if (e instanceof Error) {
            message = e.message;
        }
        else if (typeof e === "string") {
            message = e;
        }
        else {
            message = false;
        }
    }
    catch (e2) {
        console.error(e2);
    }
    const app = document.getElementById("app");
    const err = document.getElementById("js-init-error");
    try {
        app?.classList?.add("hide");
        if (!err) {
            alert("An error occurred, and the HTML to display it is missing!");
            return;
        }
        const target = err.querySelector(".js-error-message");
        if (message && target instanceof HTMLElement) {
            target.innerText = message;
            target.parentElement.classList.remove("hide");
        }
    }
    catch (e3) {
        console.error(e3);
    }
    err?.classList?.remove("hide");
}
function setupGlobalElements() {
    const edit = document.getElementById("editor");
    guideType = document.getElementById("guide-type");
    if (edit) {
        editor = new view_1.BlockEditor(edit, EDITOR_MAX_WIDTH, EDITOR_MIN_WIDTH);
    }
    const preview = document.getElementById("preview");
    if (preview instanceof HTMLCanvasElement) {
        previewer = new view_1.Previewer(preview, new model_1.RectBounds(undefined, PREVIEW_MAX_HEIGHT), new model_1.RectBounds(undefined, PREVIEW_MIN_HEIGHT));
    }
    const miniPreview = document.getElementById("mini-preview");
    if (miniPreview instanceof HTMLCanvasElement) {
        miniPreviewer = new view_1.Previewer(miniPreview, new model_1.RectBounds(undefined, editor?.width ?? EDITOR_MAX_WIDTH), new model_1.RectBounds(undefined, EDITOR_MIN_WIDTH));
    }
    for (const [id, tool] of Object.entries(toolForId)) {
        if (ui.selectedTool === tool) {
            const button = document.getElementById(id);
            if (button) {
                button.classList.add("active");
            }
        }
    }
}
function initJs() {
    const urlView = document.getElementById("url-display");
    if (urlView && location?.href) {
        urlView.innerText = location.href;
    }
    setupGlobalElements();
    if (!(editor && previewer)) {
        criticalError("Can't get editor and preview; doing nothing.");
        return;
    }
    try {
        initJsCore();
        document.getElementById("js-init-error")?.remove();
    }
    catch (e) {
        criticalError(e);
    }
}
exports.initJs = initJs;
function initTools() {
    const colorItems = document.getElementById("color-items");
    const canvas = editor.canvas;
    if (POINTER_EVENTS) {
        canvas.addEventListener("pointerdown", e => onEditorMouse(e, true));
        canvas.addEventListener("pointerup", onEditorMouseRelease);
        canvas.addEventListener("pointercancel", onEditorMouseRelease);
        colorItems.addEventListener("pointerdown", onPaletteDown, { capture: true });
        colorItems.addEventListener("click", onPaletteClick, { capture: true });
    }
    else {
        canvas.addEventListener("mousedown", e => onEditorMouse(e, true));
        canvas.addEventListener("mouseup", onEditorMouseRelease);
        colorItems.addEventListener("mousedown", onPaletteDown, { capture: true });
        colorItems.addEventListener("click", onPaletteClick, { capture: true });
    }
    canvas.addEventListener("contextmenu", (ev) => ev.preventDefault());
    colorItems.addEventListener("contextmenu", (ev) => ev.preventDefault());
    ui.selectedTool = ui_model_1.Tool.Paint;
    ui.setCursor(editor.canvas, getPaintClass());
    const nodeList = document.querySelectorAll(".controls, #transforms input[type=range]");
    for (let i = 0; i < nodeList.length; i++) {
        nodeList[i].addEventListener("click", onControlClick);
    }
    initSashColors();
    if (isChecked("sash-on")) {
        quilt.sash.levels = isChecked("sash-cross-on") ? model_1.Sashes.Double : model_1.Sashes.Single;
    }
    initGuides();
}
function initQuiltResize() {
    const quiltW = document.getElementById("quilt-size-w");
    const quiltH = document.getElementById("quilt-size-h");
    if (!(quiltW instanceof HTMLInputElement && quiltH instanceof HTMLInputElement)) {
        return;
    }
    const w = parseInt(quiltW.value, 10);
    const h = parseInt(quiltH.value, 10);
    if (isNaN(w) || isNaN(h) || w <= 0 || h <= 0) {
        return;
    }
    quilt.resize(new model_1.Rect(w, h));
    const root = quiltW.closest(".control");
    root.addEventListener("input", onQuiltSize);
}
function initBorders() {
    ui.borderTemplate = document.getElementById("border-item");
    getPalette(ui.borderTemplate).forEach(addBorder);
    const root = ui.borderTemplate.parentElement;
    root.addEventListener("input", onBorderSize);
    const newBorder = () => {
        addBorder();
        updatePreview(quilt, previewer);
        if (quilt.borders.length >= BORDER_LIMIT) {
            document.getElementById("border-new").classList.add("hide");
        }
    };
    document.getElementById("border-new").addEventListener("click", newBorder);
}
function initSashColors() {
    const colors = getPalette(document.getElementById("sashing"));
    const targets = ["main-sash-color", "cross-sash-color"];
    if (colors.length !== targets.length) {
        console.error("Sash palette length %d does not match UI element count %d", colors.length, targets.length);
        return;
    }
    for (let i = 0; i < targets.length; i++) {
        const node = document.getElementById(targets[i]);
        if (!node) {
            console.error(`Target element id=${targets[i]} not found`);
            break;
        }
        addSashColor(i, node, colors[i]);
    }
}
function initGuides() {
    if (guideType) {
        ui.guides = new model_1.Guide(guideType.value);
        guideType.addEventListener("change", updateGuideColor);
        guideType.addEventListener("keyup", updateGuideColor);
    }
}
function initColors() {
    ui.colorTemplate = document.getElementById("color-item");
    const colorBox = ui.colorTemplate.parentNode;
    if (!(ui.colorTemplate && colorBox instanceof Element)) {
        console.error("Invalid HTML: missing *>template#color-item");
        return;
    }
    getPalette(colorBox).forEach(addColor);
    const colorIndex = Math.min(ui.paintColors[0], quilt.colorSet.length - 1);
    if (colorIndex > -1) {
        document.getElementById(`color${colorIndex}`).classList.add("selected");
        showActiveColor(0);
    }
    showActiveColor(1);
    document.getElementById("color-new").addEventListener("click", createColor);
}
function initTabs() {
    const root = document.getElementById("tabs-app");
    if (!root) {
        console.error("No #tabs-app element found");
        return;
    }
    return new tabs_1.TabGroup(root);
}
function initPrint() {
    const printTab = document.getElementById("tab-print");
    if (!printTab) {
        return;
    }
    for (const btn of printTab.querySelectorAll(".print-button")) {
        btn.addEventListener("click", (ev) => {
            ev.preventDefault();
            window.print();
        });
        btn.classList.remove("hide");
    }
}
function createColor() {
    if (quilt.colorSet.length >= COLOR_LIMIT) {
        return;
    }
    const i = addColor(randomColor());
    setPaintColor(i);
    if (i + 1 >= COLOR_LIMIT) {
        document.getElementById("color-new").classList.add("hide");
    }
}
function newColorPicker(button, value) {
    return new pickr_1.default({
        el: button,
        theme: "nano",
        lockOpacity: true,
        default: value,
        defaultRepresentation: "HSLA",
        adjustableNumbers: true,
        components: {
            preview: true,
            hue: true,
            interaction: {
                hex: true,
                hsla: true,
                hsva: false,
                rgba: false,
                cmyk: false,
                input: true,
                cancel: true,
                save: false,
                clear: false
            }
        },
        i18n: {
            "btn:cancel": "Reset",
            "aria:btn:cancel": "Reset and keep open"
        }
    });
}
function addColor(value) {
    const i = quilt.colorSet.length;
    const item = ui.colorTemplate.content.cloneNode(true);
    const button = item.querySelector(".color-button");
    if (!button) {
        console.error("Cannot find '.color-button' in ui.colorTemplate");
        return;
    }
    const dataNode = button.parentElement;
    dataNode.setAttribute("data-color-id", `${i}`);
    dataNode.id = `color${i}`;
    quilt.colorSet[i] = value;
    const picker = newColorPicker(button, value);
    picker.on("change", (newValue) => onColorChanged(i, newValue));
    picker.on("hide", () => onColorPickerHide(i));
    picker.on("cancel", () => onColorReset(i));
    ui.colorTemplate.parentNode.appendChild(item);
    pickers[i] = new ui_model_1.PickrHandle(picker, value);
    return i;
}
function onColorPickerHide(i) {
    pickers[i].saveColor(quilt.colorSet[i]);
    document.getElementById("color-items").focus({ preventScroll: true });
    setPaintColor(i);
}
function onColorChanged(i, value) {
    quilt.colorSet[i] = value.toHSLA().toString();
    updateView();
}
function onColorReset(i) {
    quilt.colorSet[i] = pickers[i].saved;
    updateView();
}
function onSashColorPickerHide(i) {
    pickers[`sash.${i}`].saveColor(quilt.sash.colors[i]);
}
function onSashColorChanged(i, value) {
    quilt.sash.colors[i] = value.toHSLA().toString();
    updatePreview(quilt, previewer);
}
function onSashColorReset(i) {
    quilt.sash.colors[i] = pickers[`sash.${i}`].saved;
    updatePreview(quilt, previewer);
}
function addSashColor(i, button, value) {
    const picker = newColorPicker(button, value);
    picker.on("change", (newValue) => onSashColorChanged(i, newValue));
    picker.on("hide", () => onSashColorPickerHide(i));
    picker.on("cancel", () => onSashColorReset(i));
    pickers[`sash.${i}`] = new ui_model_1.PickrHandle(picker, value);
    quilt.sash.colors[i] = value;
}
function onBorderColorPickerHide(i) {
    pickers[`border.${i}`].saveColor(quilt.borders[i].color);
}
function onBorderColorChanged(i, value) {
    quilt.borders[i].color = value.toHSLA().toString();
    updatePreview(quilt, previewer);
}
function onBorderColorReset(i) {
    quilt.borders[i].color = pickers[`border.${i}`].saved;
    updatePreview(quilt, previewer);
}
function addBorder(color) {
    if (quilt.borders.length >= BORDER_LIMIT) {
        return;
    }
    const i = quilt.borders.length;
    const item = ui.borderTemplate.content.cloneNode(true);
    const range = item.querySelector("input[type=range]");
    const width = 1 + Math.floor(Math.random() * 3);
    const border = new model_1.Border(width, color || randomColor());
    item.querySelector("p").appendChild(document.createTextNode(`${i + 1}`));
    range.id = `borderWidth${i}`;
    range.setAttribute("data-border-index", `${i}`);
    range.value = `${border.cellWidth}`;
    const picker = newColorPicker(item.querySelector(".color-button"), border.color);
    picker.on("change", (newValue) => onBorderColorChanged(i, newValue));
    picker.on("hide", () => onBorderColorPickerHide(i));
    picker.on("cancel", () => onBorderColorReset(i));
    quilt.borders[i] = border;
    pickers[`border.${i}`] = new ui_model_1.PickrHandle(picker, border.color);
    ui.borderTemplate.parentElement.appendChild(item);
}
function onTabChange(_ev) {
    updateView();
}
function isButtonRelevant(ev) {
    return !!(ev.buttons && ev.buttons < 3);
}
function isPrimaryButton(ev) {
    return ev.buttons === 1;
}
function isSecondaryButton(ev) {
    return ev.buttons === 2;
}
function editorClearMoveHandler() {
    editor.canvas.removeEventListener(POINTER_MOVE, onEditorMouse);
    ui.moveStatus = ui_model_1.Move.Allow;
}
function editorSetMoveHandler() {
    ui.moveStatus = ui_model_1.Move.Tracking;
    editor.canvas.addEventListener(POINTER_MOVE, onEditorMouse);
}
function onEditorMouseRelease(ev) {
    ev.preventDefault();
    editor.canvas.classList.remove("mouse-down");
    if (ui.moveStatus !== ui_model_1.Move.Ignore) {
        editorClearMoveHandler();
    }
}
function onEditorMouse(ev, isMouseDown) {
    if (ev.buttons && !isButtonRelevant(ev)) {
        return;
    }
    ev.preventDefault();
    if (!ev.buttons) {
        editorClearMoveHandler();
        return;
    }
    if (isMouseDown) {
        editor.canvas.classList.add("mouse-down");
        if (ui.moveStatus === ui_model_1.Move.Allow) {
            editorSetMoveHandler();
        }
    }
    const rect = editor.canvas.getBoundingClientRect();
    const x = ev.clientX - rect.left;
    const y = ev.clientY - rect.top;
    const _ = Math.floor;
    const sz = quilt.blockCells;
    const cellPx = editor.width / sz;
    const index = _(x / cellPx) + sz * _(y / cellPx);
    const blk = editor.currentBlock;
    const isSecondaryClick = isSecondaryButton(ev);
    switch (ui.selectedTool) {
        case ui_model_1.Tool.Paint:
            const top = _(index / sz) * cellPx;
            const left = _(index % sz) * cellPx;
            const hitX = x - left;
            const hitY = y - top;
            const colorIndex = hitX > hitY ?
                (hitX > cellPx - hitY ? 1 : 0) :
                (hitX > cellPx - hitY ? 2 : 3);
            quilt.blocks[blk].paintSubCell(index, colorIndex, ui.paintColors[isSecondaryClick ? 1 : 0]);
            break;
        case ui_model_1.Tool.SpinR:
        case ui_model_1.Tool.SpinL:
            const spinLeft = ui.selectedTool === ui_model_1.Tool.SpinL;
            quilt.blocks[blk].spinCell(index, spinLeft !== isSecondaryClick);
            break;
        case ui_model_1.Tool.FlipH:
        case ui_model_1.Tool.FlipV:
            const flipVertical = ui.selectedTool === ui_model_1.Tool.FlipV;
            quilt.blocks[blk].flipCell(index, flipVertical !== isSecondaryClick);
            break;
        default:
            console.error("Unknown tool selected: %d", ui.selectedTool);
    }
    updateView();
}
function onBorderSize(ev) {
    if (!(ev instanceof Event && ev.target instanceof HTMLInputElement)) {
        return;
    }
    const i = parseInt(ev.target.getAttribute("data-border-index") || "0", 10) || 0;
    quilt.borders[i].cellWidth = parseInt(ev.target.value, 10);
    updatePreview(quilt, previewer);
}
function onQuiltSize(ev) {
    if (!(ev instanceof Event && ev.target instanceof HTMLInputElement)) {
        return;
    }
    const dir = ev.target.getAttribute("data-direction");
    const i = parseInt(ev.target.value, 10);
    if (isNaN(i) || i < 1 || (dir !== "h" && dir !== "w")) {
        return;
    }
    const cs = quilt.shape;
    quilt.resize(new model_1.Rect(dir === "w" ? i : cs.w, dir === "h" ? i : cs.h));
    updatePreview(quilt, previewer);
}
function onControlClick(ev) {
    const target = ev.target;
    if (!(target instanceof Element)) {
        return;
    }
    const parentInput = target.closest("button, input");
    if (!parentInput) {
        return;
    }
    const classes = parentInput.classList;
    if (classes.contains("resize")) {
        onResizeInput(ev);
    }
    else if (classes.contains("sash-select")) {
        onSashChange(ev);
    }
    else if (classes.contains("tool-item")) {
        onToolChange(ev, parentInput);
    }
    else if (classes.contains("roll")) {
        onRollerClick(ev);
    }
    else if (classes.contains("download")) {
        onDownload(ev);
    }
}
function onPaletteDown(ev) {
    ui.colorEvents = ui_model_1.Click.Allow;
    if (!isButtonRelevant(ev) || !(ev.target instanceof HTMLButtonElement)) {
        return;
    }
    const node = ev.target.closest("label.color-item");
    if (!(node && node instanceof HTMLElement)) {
        console.error("label.color-item element not found in event stack");
        return;
    }
    const colorIndex = parseInt(node.getAttribute("data-color-id"), 10);
    if (isPrimaryButton(ev) && colorIndex === ui.paintColors[0]) {
        return;
    }
    ev.preventDefault();
    ev.stopPropagation();
    ui.colorEvents = ui_model_1.Click.Ignore;
    setPaintColor(colorIndex, isSecondaryButton(ev) ? 1 : 0);
}
function onPaletteClick(ev) {
    if (ui.colorEvents === ui_model_1.Click.Ignore) {
        ev.stopPropagation();
        ev.preventDefault();
    }
    ui.colorEvents = ui_model_1.Click.Allow;
}
function onToolChange(ev, node) {
    const region = ev.currentTarget;
    if (!((node.id || "") in toolForId && node instanceof HTMLElement)) {
        return;
    }
    ui.selectedTool = toolForId[node.id];
    const data = node.dataset;
    if (ui.moveStatus === ui_model_1.Move.Tracking) {
        editorClearMoveHandler();
    }
    ui.moveStatus = data.moveTracking === "1" ? ui_model_1.Move.Allow : ui_model_1.Move.Ignore;
    ui.setCursor(editor.canvas, data.cursorType);
    if (region instanceof Element) {
        for (const button of region.querySelectorAll(".tool-item.active")) {
            button.classList.remove("active");
        }
    }
    node.classList.add("active");
}
function onSashChange(ev) {
    if (ev.defaultPrevented) {
        return;
    }
    const main = document.getElementById("sash-on");
    const cross = document.getElementById("sash-cross-on");
    quilt.sash.levels = main.checked
        ? cross.checked
            ? model_1.Sashes.Double
            : model_1.Sashes.Single
        : model_1.Sashes.None;
    updatePreview(quilt, previewer);
}
function onDownload(ev) {
    const node = ev.target;
    ev.preventDefault();
    if (!(node instanceof HTMLButtonElement)) {
        return;
    }
    const isPreview = node.id === "download-preview";
    const source = isPreview ? renderDownload(quilt) : editor.canvas;
    const basename = isPreview ? "quilt" : "block";
    const link = document.createElement("a");
    link.setAttribute("href", source.toDataURL("image/png"));
    link.setAttribute("download", `${basename}.png`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}
function onRollerClick(ev) {
    const movers = {
        "roll-up": (b) => b.rollUp(),
        "roll-down": (b) => b.rollDown(),
        "roll-left": (b) => b.rollLeft(),
        "roll-right": (b) => b.rollRight()
    };
    if (!(ev.target instanceof Element)) {
        return;
    }
    const id = ev.target.id;
    const callback = movers[id];
    if (callback) {
        callback(quilt.blocks[editor.currentBlock]);
        updateView();
    }
}
function onResizeInput(ev) {
    const node = ev.target;
    if (!(node instanceof HTMLInputElement)) {
        return;
    }
    quilt.blockCells = parseInt(node.value, 10);
    updateView();
}
function onResizeViewport() {
    const width = Math.min(window.innerWidth, 1600) - 20 - VIEWPORT_MARGIN;
    const height = window.innerHeight - VIEWPORT_MARGIN;
    const curShape = quilt.shape;
    const previewAspect = curShape.w / curShape.h;
    const modPxH = 30;
    let gridWidth;
    gridWidth = width * (4 / 9);
    editor.resizeToBounds(gridWidth, height);
    gridWidth = width / 3;
    miniPreviewer.resizeToBounds(new model_1.Rect(gridWidth, height), previewAspect, modPxH);
    gridWidth = width * (7 / 9);
    previewer.resizeToBounds(new model_1.Rect(gridWidth, height), previewAspect, modPxH);
    updateView();
}
function updateGuideColor() {
    ui.guides.type = guideType.value;
    editor.render(quilt, ui.guides);
}
function updatePreview(quilt, preview) {
    const draw = preview.drawSize;
    const cellSizeFn = (cells) => {
        const minDimension = Math.min(draw.w / cells.w, draw.h / cells.h);
        return 2 * Math.floor(minDimension / 2);
    };
    preview.render(quilt, cellSizeFn, editor.state);
}
function updatePrintPreview(_ev) {
    let canvas = document.getElementById("print-preview-canvas");
    const grid = document.getElementById("tab-print-grid");
    for (const block of grid.querySelectorAll(".print-block")) {
        block.remove();
    }
    const px = (grid.clientWidth * 0.7 - 10) | 0;
    const pxMaxHeight = (px * 1.6) | 0;
    const pxHeight = quilt.getHeightForWidth(px);
    const printPreviewer = new view_1.Previewer(canvas, new model_1.Rect(px, pxMaxHeight), new model_1.RectBounds(undefined, pxHeight));
    printPreviewer.DPR = PRINT_RATIO;
    updatePreview(quilt, printPreviewer);
    canvas.style.width = `${((canvas.width / PRINT_RATIO) | 0)}px`;
    canvas.style.height = `${((canvas.height / PRINT_RATIO) | 0)}px`;
    const colors = quilt.colorSet;
    for (const block of quilt.blocks) {
        canvas = document.createElement("canvas");
        const blockParent = document.createElement("div");
        blockParent.className = "print-block";
        blockParent.appendChild(canvas);
        grid.appendChild(blockParent);
        let pxHiRes = Math.ceil(PRINT_RATIO * (grid.clientWidth * 0.3 - 10)) | 0;
        if (PRINT_RATIO >= 2) {
            pxHiRes -= pxHiRes % PRINT_RATIO;
        }
        const px = (pxHiRes / PRINT_RATIO) | 0;
        canvas.width = pxHiRes;
        canvas.height = pxHiRes;
        canvas.style.width = `${px}px`;
        canvas.style.height = `${px}px`;
        block.renderTo(canvas, colors, 0.5);
    }
}
function renderDownload(quilt) {
    const canvas = document.createElement("canvas");
    let renderer = new view_1.Previewer(canvas, new model_1.RectBounds(undefined, DOWNLOAD_MIN_HEIGHT));
    renderer.DPR = 1;
    renderer.render(quilt, (cells) => Math.max(12, 2 * Math.ceil(DOWNLOAD_MIN_HEIGHT / cells.h / 2)));
    return canvas;
}
function updateView() {
    switch (ui.tabs.current) {
        case "tab-block":
            editor.render(quilt, ui.guides);
            updatePreview(quilt, miniPreviewer);
            break;
        case "tab-quilt":
            updatePreview(quilt, previewer);
            break;
        case "tab-print":
            updatePrintPreview();
            break;
        default:
            console.error(`unknown tab name '${ui.tabs.current}'`);
    }
}
function randomColor() {
    const hue = Math.floor(Math.random() * 360);
    const sat = 45 + Math.floor(Math.random() * 35);
    const lns = 35 + Math.floor(Math.random() * 40);
    return `hsla(${hue}, ${sat}%, ${lns}%, 1.0)`;
}
